import React, { useState } from "react"
import { Link } from 'react-router-dom';
import VivaLogo from '../../assests/images/VivaLogo.png'
import user_image from '../../assests/images/user.svg'
//react toast 
import { toast } from 'react-toastify';

import { useAuth } from "../../context/auth";
import BlurLoader from "../Loder/BlurLoader";
import { API_SERVER } from "../../Utils";
import { post } from "../../apiservices/service";
import { Token } from "../Common/Common";

const Header = ({ Handletoggle, HandleheaderToogle }) => {
    const { user, logout, sessionExpired } = useAuth()
    const TokenData = Token()
    const [loading, setLoading] = useState(false);
    const loginResponse = JSON.parse(localStorage.getItem("loginResponse"));
    //console.log(loginResponse);
    const userLogOut = () => {

        setLoading(true)
        post(`${API_SERVER}api/EmployeeLogin/Logout`, { ...TokenData, EmpCode: user.empCode }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    toast.error(res.message)
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else {
                    setLoading(false)
                    logout(res)
                }
            }
        });
    }  
    

    return (
        <>
            <nav className={`navbar navbar-expand-lg fixed-top navbar-light bg-light main-header p-0`}>
                <div className="container-fluid align-items-center ">

                    <Link to='/Dashboard' className=''>
                        <img src={VivaLogo} className="icon" alt='Viva HRMS logo' width={140} style={{ padding:'4px' }} /> 
                       
                    </Link>

                    <i onClick={() => {
                        HandleheaderToogle()
                        Handletoggle()
                    } } className="fa-solid fa-bars mx-3"></i>
                   

                    <ul className="navbar-nav ms-auto d-flex flex-row nav-side-icon align-items-center">
                        
                        <li key='an' className="nav-item dropdown">
                            <div className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src={loginResponse.profile ? 'data:application/jpg;base64,' + loginResponse.profile : user_image}
                                    alt='user' style={{ width: '50px', height: '50px', borderRadius: '50%' }} />
                            </div>
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li className='px-3 pb-2 border-bottom'>
                                    <p className='m-0' style={{ fontSize: '13px' }}><span className='green_dot'></span>{user ? user.empCode : 'lorem data'} </p>
                                    <p className='m-0' style={{ fontSize: '13px' }}><span className='ps-3 text-center'></span>{user ? user.employeeName :'lorem data'}</p>
                                </li>
                                <li key='am'>
                                    <Link className="dropdown-item" style={{ fontSize: '13px' }} to='User/ChangePassword'>Change Password</Link>
                                </li>
                                <li key='al'>
                                    <button className="dropdown-item" style={{ fontSize: '13px' }} onClick={userLogOut}>Logout</button>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </nav>
            {/* Loder start*/}
            {loading && < BlurLoader />}
            {/* Loder End*/}
        </>
    )
}
export default Header;